import { LoginGuard } from './../../shared/login/login.guard';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  { path: 'register', component: RegisterComponent },
  { path: 'active/:token', component: ActivateAccountComponent },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard], resolve: { type: LoginGuard }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserAuthenticationRoutingModule { }
